import {DocumentManager} from "PDFImporter/Manager/PDFManager/DocumentManager";
import {FormulaGroup} from "PDFImporter/Dialogs/Dialogs/FormFieldPicker";


export class FixedFieldDictionary {
    public static GenerateFixedFields(documentManager:DocumentManager)
    {
        let groups:FormulaGroup[]=[];



        return groups;
    }


}


